// src/components/cloud/FolderTreeView.jsx
import React from 'react';
import { Box } from '@mui/material';
import { TreeView } from '@mui/x-tree-view/TreeView';
import { TreeItem } from '@mui/x-tree-view/TreeItem';
import { FaFolder, FaFolderOpen, FaChevronRight } from 'react-icons/fa';

// Funzione per convertire una lista piatta di percorsi in una struttura ad albero
const buildTree = (paths) => {
    const root = { name: 'Cartella Principale', path: '', children: [] };
    
    // Non abbiamo più bisogno della mappa esterna, la logica è contenuta in una funzione
    const findOrCreateNode = (pathSegments, parentNode) => {
        if (pathSegments.length === 0) {
            return; // Fine della ricorsione
        }

        const currentSegment = pathSegments[0];
        const remainingSegments = pathSegments.slice(1);
        
        let childNode = parentNode.children.find(child => child.name === currentSegment);

        if (!childNode) {
            const newPath = parentNode.path ? `${parentNode.path}/${currentSegment}` : currentSegment;
            childNode = {
                name: currentSegment,
                path: newPath,
                children: []
            };
            parentNode.children.push(childNode);
        }

        findOrCreateNode(remainingSegments, childNode);
    };

    paths.forEach(fullPath => {
        if (!fullPath || !fullPath.endsWith('/')) return;
        
        const pathSegments = fullPath.slice(0, -1).split('/');
        findOrCreateNode(pathSegments, root);
    });

    return root;
};

const FolderTreeView = ({ allFiles, onSelectNode }) => {
    // Estrai solo i percorsi delle cartelle e la root
    const folderPaths = ['']; // Aggiungi la root di default
    allFiles.forEach(file => {
        // Usiamo file.name perché è il percorso completo relativo
        if (file.isDir && !file.isParent && file.name) {
            folderPaths.push(file.name);
        }
    });

    const folderTree = buildTree(Array.from(new Set(folderPaths)));

    const renderTree = (nodes) => (
        <TreeItem
            key={nodes.path}
            nodeId={nodes.path || 'root'} // nodeId è obbligatorio e deve essere una stringa
            label={nodes.name}
            onClick={() => onSelectNode(nodes.path ? nodes.path + '/' : '')}
        >
            {Array.isArray(nodes.children)
                ? nodes.children.map((node) => renderTree(node))
                : null}
        </TreeItem>
    );

    return (
        <Box sx={{ minHeight: 220, flexGrow: 1, maxWidth: 400, overflowY: 'auto', border: '1px solid #ddd', p: 1 }}>
            <TreeView
                aria-label="folder navigator"
                defaultCollapseIcon={<FaFolderOpen />}
                defaultExpandIcon={<FaChevronRight />}
                sx={{ flexGrow: 1 }}
            >
                {renderTree(folderTree)}
            </TreeView>
        </Box>
    );
};

export default FolderTreeView;